import DataProvider from '@app/model/_common/DataProvider';
import HotelRoomMappingType from '@app/model/market_state/HotelRoomMappingType';
import type HotelRoomWithMapping from '@app/model/company_hotel_room_mappings_type_configuration/HotelRoomWithMapping';

export function isSoldOutPlaceholder(roomMapping: HotelRoomWithMapping): boolean {
	// HotelPricesMobilePageHtmlParser.SOLD_OUT_ROOM_NAME supplies this exact name.
	return roomMapping.provider === DataProvider.BOOKING
		&& roomMapping.roomName === 'Sold out'
		&& roomMapping.roomMappingType === HotelRoomMappingType.NONE;
}
